var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.033,
    height: 15.644,
    viewBox: "0 0 12.033 15.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-water",
    "data-name": "Icon ionic-ios-water",
    d: "M16.377,7.075a16.816,16.816,0,0,0-3.414-3.633.322.322,0,0,0-.391,0,16.61,16.61,0,0,0-3.4,3.629,11.407,11.407,0,0,0-2.414,6.427c0,.045,0,.094,0,.139a4.914,4.914,0,0,0,.41,1.959,5.284,5.284,0,0,0,.572.989,6.208,6.208,0,0,0,5.031,2.437c3.324,0,6.02-2.41,6.02-5.385A11.451,11.451,0,0,0,16.377,7.075Zm-3.234,9.939h-.019a.33.33,0,0,1-.1-.643,4.682,4.682,0,0,0,3.249-3.038.327.327,0,0,1,.632.117V13.5A3.649,3.649,0,0,1,13.143,17.014Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#1c9d87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/waterDrop.a9133ee8af43250c5c9c32acb2b16009.svg";
export { ForwardRef as ReactComponent };